<template>
    <Card :title="$route.meta.title" dis-hover>
        <Form inline>
            <FormItem>
                <Select v-model="query.status" placeholder="" style="width:200px;">
                    <Option :value="-1">全部</Option>
                    <Option :value="0">合格</Option>
                    <Option :value="1">不合格</Option>
                </Select>
            </FormItem>
            <FormItem>
                <Select v-model="query.checkStatus" placeholder="" style="width:200px;">
                    <Option :value="-1">全部</Option>
                    <Option :value="0">未审核</Option>
                    <Option :value="1">已审核</Option>
                    <Option :value="2">已批准</Option>
                </Select>
            </FormItem>
            <FormItem>
                <Input v-model="query.reportNo" placeholder="报告编号" style="width:200px;"></Input>
            </FormItem>
            <FormItem>
                <Input v-model="query.plateNo" placeholder="车牌号/环保登记号码" style="width:200px;"></Input>
            </FormItem>
            <FormItem>
                <Button type="primary" icon="ios-search" @click="refreshGetTableData">查询</Button>
            </FormItem>
            <Button type="success" icon="md-add" @click="handleOperation(null, 'ADD')">添加</Button>
        </Form>

        <Table :loading="tableLoading" :columns="tableColumns" :data="tableList">
            <template slot-scope="{row}" slot="archiveInfo">
                <span>{{ row.archiveInfo.plateNo || '无' }}</span>
            </template>
            <template slot-scope="{row}" slot="epNo">
                <span>{{ row.archiveInfo.epNo }}</span>
            </template>
            <template slot-scope="{row}" slot="sync">
                <span color="success" v-if="row.syncState == 1 || row.syncStatus == 1">已同步<br />[{{ row.syncTime
                }}]</span>
                <span v-else>
                    <span color="default" v-if="row.syncDo == 1">同步失败<br />[{{ row.syncLog }}]</span>
                    <span color="error" v-else>审批后自动同步</span>
                </span>
            </template>
            <template slot-scope="{row}" slot="status">
                <span>{{ row.status == 0 ? '合格' : '不合格' }}</span>
            </template>

            <template slot-scope="{row}" slot="operation">
                <a class="opt-txt" @click="handleOperation(row, 'DETAIL')">详情</a>
                <a class="opt-txt" :href="'/supervise/admin/report/download?id=' + row.id" target="_blank">下载</a>
                <a class="opt-txt" v-if="row.checkStatus == 0" @click="handleOperation(row, 'CHECK1')">审核</a>
                <a class="opt-txt" v-if="row.checkStatus == 1" @click="handleOperation(row, 'CHECK2')">批准</a>
                <a v-if="row.checkStatus != 2" class="opt-txt" @click="handleOperation(row, 'DELETE')">删除</a>
                <br>
                <!--<template  v-if="row.checkStatus>0">-->
                <a class="opt-txt" :href="'/supervise/print/report?id=' + row.id" target="_blank">报告打印</a>
                <!--</template>-->
                <a class="opt-txt" @click="handleOperation(row, 'ATTACH')">附件</a>
                <br>
                <!--<a class="opt-txt" v-if="row.checkStatus==0" @click="handleOperation(row,'UPDATE')">修改</a>-->
                <a class="opt-txt" @click="handleOperation(row, 'SCAN_PIC')">上传图片及检测视频</a>
            </template>
        </Table>
        <page-model :paging="page" :total="total" @page-change="handlePageChange"></page-model>

        <Modal title="凭证查看" v-model="voucherShow" :footer-hide="true"><img :src="imgUrl | prepandImg"
                style="width: 100%" /></Modal>
        <report-scan-edit v-model="reportScanVisible" :dataSource="modalForm" :detail="detail"
            @on-success="getTableData"></report-scan-edit>
        <report-attach-edit v-model="reportAttachVisible" :dataSource="modalForm" :detail="detail"
            @on-success="getTableData"></report-attach-edit>
        <report-edit v-model="reportVisible" :dataSource="modalForm" :detail="detail" @on-success="getTableData">
        </report-edit>
        <report-print v-model="printVisible" :dataSource="modalForm"></report-print>
        <report-check v-model="checkVisible" :dataSource="modalForm" @on-success="getTableData"></report-check>
        <report-approve v-model="approveVisible" :dataSource="modalForm" @on-success="getTableData"></report-approve>
        <report-sign v-model="signVisible" :dataSource="modalForm" @on-success="getTableData"></report-sign>
        <report-update v-model="updateVisible" :dataSource="modalForm" @on-success="getTableData"></report-update>
    </Card>
</template>
<script>
import iEquip from '@/module/main/api/iEquip';
import iExam from '@/module/main/api/iExam';
import tableHelper from '@/mixins/tableHelper';
import rules from '@/libs/rules';
import DoPicture from '@/components/auto-form/DoPicture';
import EquipSearch from '@/module/main/components/EquipSearch';
import ReportEdit from '@/module/main/components/ReportEdit';
import ReportScanPicEdit from '@/module/main/components/ReportScanPicEdit';
import ReportAttachEdit from '@/module/main/components/ReportAttachEdit';
import ReportCheck from '@/module/main/components/ReportCheck';
import ReportApprove from '@/module/main/components/ReportApprove';
import ReportSign from '@/module/main/components/ReportSign';
import ReportUpdate from '@/module/main/components/ReportUpdate';
import ReportPrint from '@/module/main/components/ReportPrint';
import _don from '@/libs/doson'
import ReportScanEdit from "../../components/ReportScanPicEdit";

const modalFormTemplate = {
    id: null,
    equipment: {
        id: null
    },
    plateNo: null,
    voucher: null,
    remark: null,
    startTime: null,
    endTime: null,
};

export default {
    name: "exam_mng",
    mixins: [tableHelper],
    components: {
        ReportScanEdit, ReportApprove, ReportSign,
        DoPicture, EquipSearch, ReportEdit, ReportPrint, ReportCheck, ReportScanPicEdit, ReportUpdate, ReportAttachEdit
    },
    data() {
        return {
            rules,
            query: {
                reportNo: null,
                plateNo: null,
                status: -1,
                checkStatus: -1,
                printStatus: -1
            },
            tableColumns: [
                { title: '序号', key: 'idx', width: 80 },
                { title: '报告编号', key: 'reportNo', width: 160 },
                { title: '车牌号', slot: 'archiveInfo', width: 100 },
                { title: '环保登记号码', slot: 'epNo', width: 120 },
                { title: '烟度值', key: 'smokeVal', width: 80 },
                { title: '限值', key: 'limitVal', width: 80 },
                { title: '检测日期', key: 'examDate', width: 120 },
                { title: '检测地址', key: 'examAddress', minWidth: 140, tooltip: true },
                { title: '同步状态', slot: 'sync', minWidth: 180 },
                { title: '是否合格', slot: 'status', width: 100 },
                { title: '操作', slot: 'operation', width: 200, fixed: 'right' }
            ],
            reportScanVisible: false,
            reportVisible: false,
            reportAttachVisible: false,
            modalForm: {},
            detail: false,

            printVisible: false,
            checkVisible: false,
            approveVisible: false,
            updateVisible: false,
            signVisible: false,

            imgUrl: '',
            voucherShow: false,
        }
    },
    mounted() {
        this.getTableData()
    },
    methods: {
        getTableData() {
            //iEquip.reportList(this.page, {status:this.query.status==-1?null:this.query.status,plateNo:this.query.plateNo,reportNo:this.query.reportNo}).then(res => {
            iEquip.reportList(this.page, this.query).then(res => {
                var i = 1
                this.tableList = res.content.map(e => {
                    e.archiveInfo = JSON.parse(e.archiveInfo)
                    e.plateNo = e.archiveInfo.plateNo || e.archiveInfo.epNo
                    e.idx = (this.page.page - 1) * this.page.size + i++
                    return e
                });
                this.total = res.totalElements
            }).loadingSwitch(this, 'tableLoading');
        },
        showVoucher(voucher) {
            this.imgUrl = voucher
            this.voucherShow = true
        },
        async handleOperation(row, type) {
            if (type === 'ADD') {
                this.modalForm = {}
                this.detail = false
                this.reportVisible = true
                return;
            }
            if (type === 'DETAIL') {
                this.modalForm = row
                this.detail = true
                this.reportVisible = true
                return;
            }
            if (type === 'SCAN_PIC') {
                this.modalForm = row
                this.reportScanVisible = true
                this.detail = false
                return;
            }
            if (type === 'ATTACH') {
                this.modalForm = row
                this.reportAttachVisible = true
                this.detail = false
                return;
            }

            if (type === 'SPRINT') {
                this.modalForm = row
                this.printVisible = true
                return;
            }
            if (type === 'CHECK1') {
                /*this.$Modal.confirm({
                    title: '提示',
                    content: `是否审核通过该检测报告，确认继续？`,
                    onOk: () => {
                        iEquip.reportUpdateCheck(row.id, 1).then(() => {
                            this.$Message.success('操作成功');
                            this.getTableData();
                        }).loadingSwitch(this, 'tableLoading');
                    }
                });*/
                this.modalForm = row
                this.checkVisible = true
                return;
            }
            if (type === 'CHECK2') {
                /*this.$Modal.confirm({
                    title: '提示',
                    content: `是否批准该检测报告，确认继续？`,
                    onOk: () => {
                        iEquip.reportUpdateCheck(row.id, 2).then(() => {
                            this.$Message.success('操作成功');
                            this.getTableData();
                        }).loadingSwitch(this, 'tableLoading');
                    }
                });*/
                this.modalForm = row
                this.approveVisible = true
                return;
                return;
            }
            if (type === 'UPDATE') {
                this.modalForm = row
                this.updateVisible = true
                return;
            }
            if (type === 'DELETE') {
                this.$Modal.confirm({
                    title: '提示',
                    content: `该操作将删除id为“${row.id}”的检测报告，确认继续？`,
                    onOk: () => {
                        iEquip.reportDelete(row.id).then(() => {
                            this.$Message.success('操作成功');
                            this.getTableData();
                        }).loadingSwitch(this, 'tableLoading');
                    }
                });
                return;
            }
            if (type === 'SIGN') {
                this.modalForm = row
                this.signVisible = true
                this.detail = false
                return;
            }
        },
        handleSubmit() {
            this.$refs.baseForm.validate(val => {
                if (!val) return;
                iEquip.reportAdd(this.modalForm).then(() => {
                    this.$Message.success('操作成功');
                    this.getTableData()
                    this.modalVisible = false
                });
            });
        },
        sChange(v) {
            this.modalForm.startTime = v
        },
        eChange(v) {
            this.modalForm.endTime = v
        },
        handleFlagSwitch(row) {
            iExam.updateShowSeal(row.id, row.showSeal).then(() => {
                this.$Message.success('操作成功');
                this.getTableData()
            });
        },
    },
    watch: {
        /*"modalForm.startTime"(v1, v2) {

        }*/
    },
    filters: {
        prepandImg(url) {
            if (url) {
                return '/supervise' + url
            }
            return null
        }
    }
}
</script>

<style scoped lang="less">
</style>
